const ModalActionTypes = Object.freeze({
  SHOW_MODAL: 'modals/SHOW_MODAL',
  HIDE_MODAL: 'modals/HIDE_MODAL',
});

export default ModalActionTypes;
